const getters = {
  foods: (state) => state.food.foods,
  order: (state) => state.food.order,
};
export default getters;
